
import Component from 'vue-class-component';
import Vue from 'vue';
import { settingStore } from '@/stores/index'
@Component({
})
export default class HeaderButton extends Vue {
    store = settingStore();
    toggleCollapse(){
        this.store.toggleCollapse();
    }

}
